module.exports = __webpack_public_path__ + "img/Flag_of_Mauritius.139f91a3.svg";